import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { syncStatusFilter } from 'modules/integrations/lib/DataCollection/filters'

type SyncStatusFilter = ReturnType<typeof syncStatusFilter>

export const useSyncStatusFilter = (): Partial<SyncStatusFilter> => {
  const { syncEnabled, capabilityMode, configuration } = usePrivateIntegrationsSyncContext()
  if (!syncEnabled) return {}

  return syncStatusFilter(configuration, capabilityMode)
}
